import React, { useState, useEffect } from "react";
import useB2BTranslation from "../../../b2b-common/hooks/useB2BTranslation";

const PayloadParserFactory = ({ post = null }) => {
    const { t } = useB2BTranslation('b2b-social');

    const [ParserComponent, setParserComponent] = useState(null);

    useEffect(() => {
        const loadComponent = async () => {
            if (post && post.socialPostTemplate.socialPostTemplateAcronym) {
                try {
                    const component = await import(`./parsers/PayloadParser_${post.socialPostTemplate.socialPostTemplateAcronym}.js`);
                    setParserComponent(() => component.default);
                } catch (error) {
                    console.error('Error loading component:', error);
                }
            }
        };
        loadComponent();
    }, [post]);

    if (!ParserComponent) {
        return <div>{t('Loading...')}</div>;
    }

    return <ParserComponent post={post} />;
};

export default PayloadParserFactory;